import { asApiFailure, parseFailureBody } from "@utils/apiFailure";

// The two answers the API gives about the Turnstile token on the anonymous
// onboarding endpoints (OB-06). Identified by status AND code: any other 400 is
// about the form's own fields, and an uncoded 503 is the host being down, so
// both keep the form's existing copy.
const CHECK_AGAIN = "Please complete the check again.";
const UNAVAILABLE =
    "We couldn't verify you're human right now. Please try again in a minute.";

export const captchaErrorMessage = (error: unknown): string | undefined => {
    const failure = asApiFailure(error);
    const code = parseFailureBody(failure?.detail)?.error;

    if (failure?.status === 400 && code === "captcha_failed") {
        return CHECK_AGAIN;
    }

    if (failure?.status === 503 && code === "captcha_unavailable") {
        return UNAVAILABLE;
    }

    return undefined;
};
